<template>
  <WaggonInfoBody
    :color="workpackage.color"
    :textcolor="workpackage.textcolor"
    :workpackage="workpackage"
    :info_box="wallet || $vuetify.breakpoint.smAndDown?false:true"
    :wallet="wallet"
    >
    <template #body-content>
      <div class="no-scroll-y">
      <StandardFlexBox height="26px" v-if="$route.matched[1] && $route.matched[1].name !== 'ProjectWallet'">
        <WaggonInfoStatus
        v-for="status in getStatusArray.slice(0,-1)"
        :key="status.name"
        :status="status"
        :textcolor="workpackage.textcolor"
        :selected="workpackage.status === status.name?true:false"
        width="16.66%"
        :cursor="
        hasProjectPermission({
          project_id: project_id,
          ppermission: 'Update Work Packages'
          }) ||
        getOwnTWorkPackages(project_id).includes(tworkpackage_id)?
        'pointer':'default'
        "
        @click.native="
          hasProjectPermission({
            project_id: project_id,
            ppermission: 'Update Work Packages'
            }) ||
          getOwnTWorkPackages(project_id).includes(tworkpackage_id)
          ?
          updateUObject({
            url: [
              {projects: project_id},
              {trains: train_id},
              {taktareas: taktarea_id},
              {twaggons: twaggon_id},
              {tworkpackages: tworkpackage_id},
            ],
            url_suffix: '/status',
            update: {
              status: workpackage.status !== status.name?status.name:'none'
            }
          }).then(() => {
            /* updateMilestoneStatus({project_id: project_id, workpackage_id: workpackage.id}) */
          })
        :''"
        />
        <WaggonInfoStatus
          :status="{name: 'stop', tooltip: 'Stop', icon: workpackage.stop_status === 'ai_stop'?'ai_stop':'exclamation-triangle-negative'}"
          :textcolor="workpackage.textcolor"
          :selected="workpackage.stop_status !== 'none'"
          width="16.66%"
          :cursor="
          hasProjectPermission({
            project_id: project_id,
            ppermission: 'Update Work Packages'
            }) ||
          getOwnTWorkPackages(project_id).includes(tworkpackage_id)?
          'pointer':'default'
          "
          @click.native="
            hasProjectPermission({
              project_id: project_id,
              ppermission: 'Update Work Packages'
              }) ||
            getOwnTWorkPackages(project_id).includes(tworkpackage_id)
            ?
            updateUObject({
              url: [
                {projects: project_id},
                {trains: train_id},
                {taktareas: taktarea_id},
                {twaggons: twaggon_id},
                {tworkpackages: tworkpackage_id},
              ],
              url_suffix: '/stopstatus',
              update: {
                stop_status: workpackage.stop_status !== 'none'?'none':'stop'
              }
            }).then(() => {
              /* updateMilestoneStatus({project_id: project_id, workpackage_id: workpackage.id}) */
            })
          :''"
          />
        <!-- updateTWorkPackageStatus({
          project_id: project_id,
          train_id: train_id,
          taktarea_id: taktarea_id,
          twaggon_id: twaggon_id,
          twork_package_id: tworkpackage_id,
          update: {
            status: workpackage.status !== status.name?status.name:'none'
          }
        }) -->
      </StandardFlexBox>
      <StandardDataField
        :text_color="workpackage.textcolor"
        :value="workpackage.name"
        readonly="true"
        />
      <StandardDataField
        :text_color="workpackage.textcolor"
        :value="workpackage.description"
        flat="true"
        :placeholder="$t('Project.Workpackage.Info.DescriptionPlaceholder')"
        :resizable="true"
        :readonly="true"
        />
      <v-divider color="black"></v-divider>
        <StandardFlexBox
          :direction="wallet?'column':'row'"
          >
          <!-- attributes planned -->
          <StandardFlexBox
            class="pa-1"
            :width="wallet?'100%':'50%'"
            direction="column"
            >
            {{$t('Project.Workpackage.Info.AttributesPlanned')}}
            <StandardFlexBox
              class="mb-1"
              >
              <StandardDataField
                :text_color="workpackage.textcolor"
              :value="workpackage.time_effort_planned"
              icon="speed"
              width="28%"
              :type="'number'"
              :readonly="true"
              />
              <div style="width: 8%; line-height: 25px; text-align: center;">/</div>
              <StandardDataField
                :text_color="workpackage.textcolor"
                :value="workpackage.manpower_planned.toFixed(2)"
                icon="accessibility"
                width="28%"
                :type="'number'"
                :readonly="true"
                />
              <div style="width: 8%; line-height: 25px; text-align: center;">=</div>
              <StandardDataField
                :text_color="workpackage.textcolor"
                :value="workpackage.manpower_planned === 0 || isNaN(Math.round((workpackage.time_effort_planned/workpackage.manpower_planned)*100) / 100)?
                        '':Math.round((workpackage.time_effort_planned/workpackage.manpower_planned)*100) / 100"
                icon="timer"
                width="28%"
                :readonly="true"
                />
            </StandardFlexBox>
            <StandardFlexBox
              class="mb-1"
              >
              <StandardDataField
                :text_color="workpackage.textcolor"
                :value="workpackage.quantity_value"
                icon="drag_indicator"
                width="33%"
                :type="'number'"
                :readonly="true"
                />
              <StandardDataField
                :text_color="workpackage.textcolor"
                :value="workpackage.quantity_unit"
                icon="drag_indicator"
                width="33%"
                :readonly="true"
                />
            </StandardFlexBox>
          </StandardFlexBox>
          <!-- attributes actual -->
          <StandardFlexBox
            v-if="hasCalendar(project_id)"
            :style="!wallet?'border-left: solid 1px black':''"
            class="pa-1"
            :width="wallet?'100%':'50%'"
            direction="column"
            >
            {{$t('Project.Workpackage.Info.AttributesActual')}} ({{ daily_report.name == 'All'?'Total | Ø | Ø':daily_report.name }})
            <StandardFlexBox>
              <StandardDataField
                :text_color="workpackage.textcolor"
                :value="getTimeEffort()"
                icon="speed"
                icon_actual="true"
                width="28%"
                :readonly="true"
                />
              <div v-if="daily_report.name != 'All'" style="width: 8%; line-height: 25px; text-align: center;">=</div>
              <div v-else style="width: 8%; line-height: 25px; text-align: center;"></div>

              <StandardDataField
                :text_color="workpackage.textcolor"
                :value="getDailyReportVal('manpower')"
                icon="accessibility"
                icon_actual="true"
                width="28%"
                :type="'number'"
                :readonly="
                hasProjectPermission({
                  project_id: project_id,
                  ppermission: 'Update Work Packages'
                  }) ||
                getOwnTWorkPackages(project_id).includes(tworkpackage_id)
                ? false:true
                "
                @changeValue="updateDailyReport(parseFloat($event), 'manpower')"
                />
              <div v-if="daily_report.name != 'All'" style="width: 8%; line-height: 25px; text-align: center;">x</div>
              <div v-else style="width: 8%; line-height: 25px; text-align: center;"></div>
              <StandardDataField
                :text_color="workpackage.textcolor"
                :value="getDailyReportVal('duration')"
                icon="timer"
                icon_actual="true"
                width="28%"
                :type="'number'"
                :readonly="
                hasProjectPermission({
                  project_id: project_id,
                  ppermission: 'Update Work Packages'
                  }) ||
                getOwnTWorkPackages(project_id).includes(tworkpackage_id)
                ? false:true
                "
                @changeValue="updateDailyReport(parseInt($event), 'duration')"
                />
                <StandardButtonSelectorHorizontal
                  class="mt-1 mb-1"
                  :options="daily_report_options"
                  @input="setDailyReportOption($event)"
                />
            </StandardFlexBox>
          </StandardFlexBox>
        </StandardFlexBox>
      <v-divider color="black"></v-divider>
      <!-- Contact -->
      <StandardFlexBox
        direction="column"
        :no_wrap="true"
        >
        {{$t('Project.Workpackage.Info.Contact')}}
        <StandardDataField
          :text_color="workpackage.textcolor"
          width="100%"
          :value="workpackage.contact_name"
          icon="account_circle"
          :readonly="true"
          />
        <StandardDataField
          :text_color="workpackage.textcolor"
          width="100%"
          :value="workpackage.contact_phone_number"
          icon="call"
          :readonly="true"
          />
        <StandardDataField
          :text_color="workpackage.textcolor"
          width="100%"
          :value="workpackage.contact_email"
          icon="email"
          :readonly="true"
          />
        </StandardFlexBox>
        <StandardFlexBox
          direction="column" :no_wrap="true"
        >
          {{ $t('Project.Workpackage.Info.Tag.Tag') }}{{$t('Project.Workpackage.Info.Tag.Me')}}
          <StandardFlexBox direction="row" justify_content="space-around" align_items="center">
            <StandardFlexBox direction="row" align_items="center">
              <div>{{ $t('Project.Workpackage.Info.Tag.Tag') }}{{$t('Project.Workpackage.Info.Tag.Wp')}}</div> <v-btn v-if="!show_scanner" @click="show_scanner = true; tag_target='wp'" icon color="black" ><v-icon>border_outer</v-icon></v-btn>
            </StandardFlexBox>
            <StandardFlexBox direction="row" align_items="center">
              <div>{{ $t('Project.Workpackage.Info.Tag.Tag') }}{{$t('Project.Workpackage.Info.Tag.Ta')}}</div> <v-btn v-if="!show_scanner" @click="show_scanner = true; tag_target='ta'" icon color="black" ><v-icon>border_outer</v-icon></v-btn>
            </StandardFlexBox>
          </StandardFlexBox>
          <div class="qr-scanner" v-if="show_scanner">
            <v-btn @click="show_scanner = false" small class="qr-scanner-cancel">Cancel</v-btn>
            <qrcode-stream @decode="onDecode"></qrcode-stream>
          </div>
          <!-- <qrcode-drop-zone class="drop-zone" v-if="show_scanner" @decode="onDecode"></qrcode-drop-zone> -->
          <v-alert @click="tag_success=false" v-if="tag_success" type="success">Tag successful!</v-alert>
          <v-alert @click="tag_fail=false" v-if="tag_fail" type="error">{{tag_fail}}</v-alert>
        </StandardFlexBox>
      </div>
    </template>
  </WaggonInfoBody>
</template>
<script>
import store from '@/store/index'
import { mapGetters } from 'vuex';

import { WaggonInfoMixin } from '@/mixins/WaggonInfo.mixin.js'
import StandardButtonSelectorHorizontal from '@/components/StandardComponents/StandardButtonSelectorHorizontal.component.vue'

export default {
  props: ['project_id', 'train_id', 'taktarea_id', 'twaggon_id', 'tworkpackage_id', 'workpackage', 'wallet'],
  mixins: [
    WaggonInfoMixin
  ],
  components: { StandardButtonSelectorHorizontal },

  data: function () {
    return {
      dailyreportkey: 0,
      show_scanner: false,
      tag_success: false,
      tag_fail: false,
      tag_target: 'wp',
      daily_report_options: [],
      daily_report: {}
    }
  },
  computed: {
    ...mapGetters('ProjectCalendar', [
      'getDatesFromTaktIndex',
      'getWeekDays',
      'hasCalendar',
    ])
  },
  created() {
    this.setDailyReports();
  },
  // mounted() {
  //   if (!this.isCloudPrint) {
  //     store.dispatch('Ultra/requestUObject', {
  //       url: [
  //         { projects: this.project_id },
  //         { trains: this.train_id },
  //         { taktareas: this.taktarea_id },
  //         { twaggons: this.twaggon_id },
  //         { tworkpackages: this.tworkpackage_id },
  //       ],
  //       url_suffix: '/additionalinformation'
  //     });
  //   }
  // },
  updated(){
    this.setDailyReports();
  },
  methods: {
    onDecode(decoded){
      // https://www.takting.com/codes?code=9FECF10C9C&signature=
      // let index_code = decoded.indexOf('?code=');
      let code = decoded.substring(35, 45);
      let signature = decoded.substring(56);
      let self = this;
      this.show_scanner = false;
      // let info = JSON.parse(decoded);
      if (this.tag_target === 'wp') {
        store.dispatch('TWorkPackage/addTWPTag', {
          project_id: this.project_id,
          train_id: this.train_id,
          taktarea_id: this.taktarea_id,
          twaggon_id: this.twaggon_id,
          tworkpackage_id: this.tworkpackage_id,
          data: {
            code: code,
            signature: signature
          }
        }).then(() => {
          self.tag_success = true;
        })
        .catch(err => {
          self.tag_fail = err;
        });
      } else {
        store.dispatch('TaktArea/addTATag', {
          project_id: this.project_id,
          train_id: this.train_id,
          taktarea_id: this.taktarea_id,
          data: {
            code: code,
            signature: signature
          }
        }).then(() => {
          self.tag_success = true;
        })
        .catch(err => {
          self.tag_fail = err;
        });
      }
    },
    setDailyReportOption(daily_report){
      this.daily_report = daily_report;
      for (var i = 0; i < this.daily_report_options.length; i++) {
        if (this.daily_report_options[i].name === this.daily_report.name) {
          this.daily_report_options[i].color = 'black';
          this.daily_report_options[i].textcolor = 'white';
        } else {
          this.daily_report_options[i].color = this.workpackage.color;
          this.daily_report_options[i].textcolor = this.workpackage.textcolor;
        }
      }
    },
    updateDailyReport(val, attr){
      let update = {};
      let update_daily_report = {};
      if (this.daily_report.name === 'All') {
        update[attr + '_actual'] = val;
        this.updateUObject({
          url: [
            {projects: this.project_id},
            {trains: this.train_id},
            {taktareas: this.taktarea_id},
            {twaggons: this.twaggon_id},
            {tworkpackages: this.tworkpackage_id}
          ],
          update: update,
        });

        update_daily_report[attr] = val;
        for (let i = 0; i < this.daily_report_options.length; i++) {
          if (this.daily_report_options[i].name != 'All') {
            if (this.dailyReportExists(this.daily_report_options[i].takt_date)) {
              this.updateUObject({
                url: [
                  {projects: this.project_id},
                  {trains: this.train_id},
                  {taktareas: this.taktarea_id},
                  {twaggons: this.twaggon_id},
                  {tworkpackages: this.tworkpackage_id},
                  {dailyreports: this.workpackage.dailyreports[i]}
                ],
                update: update_daily_report,
              });
            } else {
              let u_object = {
                manpower: 0.,
                duration: 0,
                date: this.daily_report_options[i].takt_date.toISOString()
              };
              u_object[attr] = val;
              this.createUObject({
                url: [
                  {projects: this.project_id},
                  {trains: this.train_id},
                  {taktareas: this.taktarea_id},
                  {twaggons: this.twaggon_id},
                  {tworkpackages: this.tworkpackage_id},
                  {dailyreports: ''},
                  {showWithEntitiesNormalized: ''},
                ],
                u_object: u_object,
              });
            }
          }
        }
      } else {
        let done = false;
        update[attr] = val;
        for (let i = 0; i < this.workpackage.dailyreports.length; i++) {
          if (
            this.getUObject({type: 'dailyreports', id: this.workpackage.dailyreports[i]}).date.substring(0,10) ===
            this.daily_report.takt_date.toISOString().substring(0,10)
          ) {
            // daily report already exists: update the report
            this.updateUObject({
              url: [
                {projects: this.project_id},
                {trains: this.train_id},
                {taktareas: this.taktarea_id},
                {twaggons: this.twaggon_id},
                {tworkpackages: this.tworkpackage_id},
                {dailyreports: this.workpackage.dailyreports[i]}
              ],
              update: update,
            });
            done = true;
            break;
          }
        }
        if (!done) {
          // no report with this date exists: create a new one
          let u_object = {
            manpower: 0.,
            duration: 0,
            date: this.daily_report.takt_date.toISOString()
          };
          u_object[attr] = val;
          this.createUObject({
            url: [
              {projects: this.project_id},
              {trains: this.train_id},
              {taktareas: this.taktarea_id},
              {twaggons: this.twaggon_id},
              {tworkpackages: this.tworkpackage_id},
              {dailyreports: ''},
              {showWithEntitiesNormalized: ''},
            ],
            u_object: u_object,
          });
        }
      }
    }, // end of function
    setDailyReports(){
      this.daily_report_options = [];
      let offset = this.getUObject({type:'trains', id: this.train_id}).train_start;
      offset += this.getUObject({type:'taktareas', id: this.taktarea_id}).taktarea_start;
      offset += this.getUObject({type:'twaggons', id: this.twaggon_id}).position;
      let dates = this.getDatesFromTaktIndex({
        project_id: this.project_id,
        takt_index: offset
      });
      for (var i = 0; i < dates.length; i++) {
        this.daily_report_options.push({
          name: this.getWeekDays[dates[i].getDay()], small: true,
          color: this.workpackage.color, takt_date: dates[i]
        });
      }
      this.daily_report_options.push({
        name: 'All', small: true,
        color: this.workpackage.color, takt_date: false
      });
      this.setDailyReportOption(this.daily_report_options[0]);
      // this.dailyreportkey++;
    },
    getDailyReportVal(attr){
      if (this.daily_report.name === 'All') {
        if (this.workpackage.dailyreports.length == 0) {
          return this.workpackage[attr + '_actual'];
        } else {
          let sum = 0;
          for (let i = 0; i < this.workpackage.dailyreports.length; i++) {
            sum += this.getUObject({type: 'dailyreports', id: this.workpackage.dailyreports[i]})[attr];
          }
          return Math.round(sum / this.workpackage.dailyreports.length * 100) / 100;
        }
      } else {
        for (var i = 0; i < this.workpackage.dailyreports.length; i++) {
          if (
            this.daily_report.takt_date &&
            this.getUObject({type: 'dailyreports', id: this.workpackage.dailyreports[i]}).date.substring(0,10) ===
            this.daily_report.takt_date.toISOString().substring(0,10)
          ) {
            return this.getUObject({type: 'dailyreports', id: this.workpackage.dailyreports[i]})[attr];
          }
      }
    }
    return '';
  },
  dailyReportExists(takt_date){
    for (let i = 0; i < this.workpackage.dailyreports.length; i++) {
      if (this.getUObject({type: 'dailyreports', id: this.workpackage.dailyreports[i]}).date.substring(0, 10) == takt_date.toISOString().substring(0, 10)) {
        return true;
      }
    }
    return false;
  },
  getTimeEffort(){
    if (this.daily_report.name != 'All') {
      return this.getDailyReportVal('manpower') === 0?'':Math.round((this.getDailyReportVal('duration')*this.getDailyReportVal('manpower'))*100) / 100;
    } else {
      if (this.workpackage.dailyreports.length == 0) {
        return Math.round((this.workpackage.manpower_actual * this.workpackage.duration_actual)*100) / 100;
      } else {
        let sum = 0;
        for (let i = 0; i < this.workpackage.dailyreports.length; i++) {
          sum += Math.round((
            this.getUObject({type: 'dailyreports', id: this.workpackage.dailyreports[i]}).duration *
            this.getUObject({type: 'dailyreports', id: this.workpackage.dailyreports[i]}).manpower)*100) / 100;
          }
          return sum;
      }
    }
  },
  // updateMilestoneStatus(workpackage_id) {
  //   this.getLinkedTMilestones({project_id: this.project_id, workpackage_id}).forEach((tmilestone_id) => {
  //     this.requestUObject({
  //       url: [
  //         {projects: this.project_id},
  //         {milestones: tmilestone_id},
  //         {showWithEntitiesNormalized: ''}
  //       ],
  //       no_cache: true,
  //     });
  //     this.getLinkedPMilestones({project_id: this.project_id, tmilestone_id}).forEach((pmilestone_id) => {
  //       this.requestUObject({
  //         url: [
  //           {projects: this.project_id},
  //           {milestones: pmilestone_id},
  //           {showWithEntitiesNormalized: ''}
  //         ],
  //         no_cache: true,
  //       });
  //     });
  //   });
  //
  // },
  getManPower(){

  }
}
  // beforeRouteUpdate(to, from, next) {
  //   store.dispatch('TWorkPackage/requestTWorkPackage', {
  //     project_id: to.params.project_id,
  //     train_id: to.params.train_id,
  //     taktarea_id: to.params.taktarea_id,
  //     twaggon_id: to.params.twaggon_id,
  //     twork_package_id: to.params.tworkpackage_id
  //   }).then(() => {next()})
  // },
}
</script>
<style>
  div {
    user-select: none;
  }
  .drop-zone{
    height: 50px;
    padding-top: 15px;
    width: 150px;
    background-color: snow;
    border: dashed 1px black;
    text-align: center;
    font-size: smaller;
  }
  .qr-scanner {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 15;
    top: 0px;
    left: 0px;
  }
  .qr-scanner-cancel {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 18;
  }

</style>
